import React, { Component } from "react";
import Slider from "react-animated-slider";
import "react-animated-slider/build/horizontal.css";
import Slide from "./Slide";

class Header extends Component {
    render() {
        return (
            <div className="slider-wrapper">
                <Slider autoplay={3000} infinite>
                    {/* <Slider infinite> */}
                    {this.props.slides &&
                        this.props.slides.map((slideData, slideIndex) => (
                            <div key={slideIndex}>
                                <Slide
                                    {...slideData}
                                    onClickSlide={() =>
                                        this.props.onClickSlide(slideData)
                                    }
                                />
                            </div>
                        ))}
                </Slider>
            </div>
        );
    }
}

export default Header;
